import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: 'app-dl-tabs',
    templateUrl: './dl-tabs.component.html',
    styleUrls: ['./dl-tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DlTabsComponent implements OnInit {
    @Input() list: string[] = [];
    @Input() set externalActiveItemValue(tab: string) {
        if (this.activeItem$.getValue() === tab) return
        this.setActiveTab(tab);
    }
    @Output() onChange = new EventEmitter<string>();
    activeItem$ = new BehaviorSubject<string>('');

    constructor() {
    }

    ngOnInit(): void {
        this.activeItem$
            .pipe(untilDestroyed(this))
            .subscribe((value) => this.onChange.emit(value))
    }

    setActiveTab(tab: string): void {
        // when tab toggled twice set default value
        if (this.activeItem$.getValue() === tab) {
            this.activeItem$.next('')
            return
        }

        this.activeItem$.next(tab);
    }
}
